<template>
    <div class="flex flex-col min-h-screen">
        <cookie-consent class="top-16" :cookies="[
          {
            displayName: 'Technical',
            cookieName: 'technical',
            description: 'We use technical cookies that ensure that the website can be used. Unfortunately, these cookies are absolutely necessary and cannot be disabled.',
            optional: false,
            initialStatus: true,
          },

          {
            displayName: 'Analytical',
            cookieName: 'analytical',
            description: 'We use Google Analytics to analyze the traffic of the website. You can find more information about this in our Privacy Policy statement.',
            optional: true,
            initialStatus: false,
          },
        ]"></cookie-consent>

        <nav-bar/>

        <main class="flex-grow mt-16">
            <slot></slot>
        </main>

        <new-app-footer :margin-top="marginFooter"/>

        <!-- Modal Portal -->
        <portal-target name="modal" multiple>
        </portal-target>
    </div>
</template>

<script>
import NavBar from '@/Components/NavBar';
import NewAppFooter from '@/Components/NewAppFooter';
import CookieConsent from '@/Components/CookieConsent';

export default {
    components: {
        NewAppFooter,
        NavBar,
        CookieConsent,
    },

    props: {
        marginFooter: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
